var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#389E0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20H20C19.2044 20 18.4413 20.3161 17.8787 20.8787C17.3161 21.4413 17 22.2044 17 23V37C17 37.7956 17.3161 38.5587 17.8787 39.1213C18.4413 39.6839 19.2044 40 20 40H40C40.7956 40 41.5587 39.6839 42.1213 39.1213C42.6839 38.5587 43 37.7956 43 37V23C43 22.2044 42.6839 21.4413 42.1213 20.8787C41.5587 20.3161 40.7956 20 40 20ZM32.94 29.6012C32.7999 30.2768 32.4313 30.8833 31.8962 31.3188C31.3612 31.7543 30.6924 31.9921 30.0025 31.9921C29.3126 31.9921 28.6438 31.7543 28.1088 31.3188C27.5737 30.8833 27.2051 30.2768 27.065 29.6012C26.9729 29.1486 26.727 28.7419 26.369 28.45C26.0111 28.1581 25.5631 27.9991 25.1012 28H19V26H41V28H34.8988C34.4377 28.0003 33.9909 28.1598 33.634 28.4516C33.2771 28.7433 33.0319 29.1495 32.94 29.6012ZM20 22H40C40.2652 22 40.5196 22.1054 40.7071 22.2929C40.8946 22.4804 41 22.7348 41 23V24H19V23C19 22.7348 19.1054 22.4804 19.2929 22.2929C19.4804 22.1054 19.7348 22 20 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawal);
export default __webpack_public_path__ + "static/media/withdrawal.5e07389b11f61ea68f2270a5b2ebb1f7.svg";
export { ForwardRef as ReactComponent };